import { lazy } from "react"

export const DispatcherOrderPage = lazy(() => import("./DispatcherOrderPage"))
